import React, {useState} from 'react';
import {connect, getStore, setStore} from "trim-redux";
import {makeStyles, withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {InputAdornment, useMediaQuery} from "@mui/material";
import FieldCounter from "../elements/fields/FieldCounter";
import RayaField from "../elements/fields/RayaField";
import {MapPin} from "lucide-react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {theme} from "../../../config/design/theme";


const AddressChooserField = (props) => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
           <RayaField
               placeholder={t(isMobile ? 'selectAddress'  : 'selectYourAddress')}
               slotProps={{
                   input:{
                       startAdornment: (
                           <InputAdornment position="start">
                               <MapPin className="lucide-icon-primary"/>
                           </InputAdornment>
                       ),
                   }
               }}
               className={clsx("pink-field",props.clName)}
               fullWidth
               size="small"
           />
        </>
    );
};
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
    user: state.user,
    isAuth: state.isAuth,
});
export default withStyles(Styles)(connect(mstp)(AddressChooserField));
